<template>
  <div class="wechatAuthorize_m_container">
    <p class="tip-text">为了您的账户安全，请绑定您的微信</p>
    <z-button
      type="primary"
      class="bind-btn"
      text="绑定微信账户"
      @click="handleClick">
    </z-button>
  </div>
</template>

<script>
import { Toast } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter';
import { queryParams } from '../../lib/utils';
import { bindThirdParty } from '@api/resourceApi'

const query = queryParams();

export default {
  data() {
    return {
      platId: 1,
      bindAction: 1,
      mobile: query.mobile || this.$route.query.mobile, // 手机号
      verificationCode: query.verificationCode || this.$route.query.verificationCode, // 验证码
      authCode: '', // 微信授权码
      fromlogin: query.fromlogin || this.$route.query.fromlogin || '1' //风控策略过来的为0
    }
  },
  name: 'WechatAuthorize',
  methods: {
    async bindChat() { // 根据授权码请求中台，需要传第三方id，手机号，验证码，授权场景，授权码...
      const bindRes = await bindThirdParty({
        platId: this.platId,
        mobile: this.mobile,
        verificationCode: this.verificationCode,
        bindAction: this.bindAction,
        wxBindParam: JSON.stringify({ authCode: this.authCode })
      });
      const { userInfo } = bindRes;
      //将中台获取的数据传到客户端
      native.wrap('notifyWxBindfResult')({
        ...userInfo
      }, (res) => {
        const { close } = res;
        // 如果通知回传成功则关闭页面
        if (close) {
          native.close();
        }
      })
    },
    //风控过来的走uid绑定
    async bindChatwithoutVerify() {
      const bindRes = await bindThirdParty({
        platId: 1,
        bindAction: 2,
        wxBindParam: JSON.stringify({
          authCode: this.authCode
        })
      });
      console.log('uid绑定结果', bindRes)
      this.$toast({ message: bindRes.message, duration: 800 }).then(() => {
        native.close()
      })
    },
    handleClick() {
      // 转转获取微信的授权
      native.wrap('getWechatCode')({}, (res) => {
        if (res.respCode.length > 0) {
          this.authCode = res.respCode;
          if (this.fromlogin == '0') {
            this.bindChatwithoutVerify();
          } else {
            this.bindChat();
          }
        } else { // 获取微信授权码中断
          Toast.fail({
            className: 'getWxCodeToast',
            message: '绑定微信账户失败，请稍后再试'
          })
        }
      })
    }
  }
}
</script>
<style  lang="less">
  @import './index.less';
    .z-toast__text {
      font-size: 30px;
      text-align: center;
    }
</style>